import { Grid, Group, Text } from "@mantine/core"
import { Loader } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import {
  FindSpotlightsByOrganizationIdResponseDto,
  GenerateAlertsResponseDto,
} from "~/gen/api"
import { SpotlightBox } from "~/pages/Brand/Home/components/DashboardAlerts/SpotlightBox"
import {
  SpotlightItem,
  useSpotlightItems,
} from "~/pages/Brand/Home/components/DashboardAlerts/useSpotlightItems"

type Props = {
  dashboardAlerts: GenerateAlertsResponseDto | undefined
  spotlights: FindSpotlightsByOrganizationIdResponseDto | undefined
  isLoading: boolean
  hasAlerts: boolean
}

export const DashboardAlerts = ({
  isLoading,
  dashboardAlerts,
  hasAlerts,
  spotlights,
}: Props) => {
  const { t } = useTranslation(["home"])

  const spotlightItems: SpotlightItem[] = useSpotlightItems(
    dashboardAlerts,
    spotlights
  )

  if (isLoading) {
    return <Loader fullPage />
  }

  if (!hasAlerts) {
    return (
      <Group justify="center" gap="sm">
        <Text fz="sm" style={{ textAlign: "center" }}>
          {t("notifications.empty.alerts")}
        </Text>
      </Group>
    )
  }

  return (
    <Grid>
      {spotlightItems.map((item) => (
        <Grid.Col key={item.id} span={4} h="auto">
          <SpotlightBox {...item.props} />
        </Grid.Col>
      ))}
    </Grid>
  )
}
